import { render, staticRenderFns } from "./SidebarLayout.html?vue&type=template&id=ada0297e&scoped=true&external"
import script from "./SidebarLayout.ts?vue&type=script&lang=ts&external"
export * from "./SidebarLayout.ts?vue&type=script&lang=ts&external"
import style0 from "./SidebarLayout.scss?vue&type=style&index=0&id=ada0297e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada0297e",
  null
  
)

export default component.exports